module.exports = __webpack_public_path__ + "img/templateOne.23262b86.png";